import { Observable } from 'rxjs';
import { CreateTaskListRequest, CreateTaskRequest, Person, Task, Tasklist, TasklistsApi } from 'src/app/hickory-api';
import { getPage } from './data/PageHelper';
import { getSingle } from './data/SingleHelper';
import { tasklistData } from './data/TasklistData';
import { mockHandler } from '../mock.handler';

export class MockTasklistsApi extends TasklistsApi {

  private convertFromCreateTask(request: CreateTaskRequest): Task {
    const task: Task = {
      title: request.title,
      description: request.description,
      sequence: request.sequence,
      externalId: request.externalId,
      isComplete: false,
      isSkipped: false,
      activities: []
    }
    return task;
  }
  private convertFromCreateTasklist(request: CreateTaskListRequest): Tasklist {
    const newTasklist: Tasklist = {
      id: (Math.random() * 1000000).toString(),
      externalId: request.externalId,
      incidentExternalId: request.incidentExternalId,
      title: request.title,
      description: request.description,
      createdOn: new Date(),
      modifiedOn: new Date(),
      owner: this.createPerson(request.ownerId),
      owners: request.ownerIds.map(id => this.createPerson(id)),
      ownerLabel: request.ownerLabel,
      assignees: request.assigneeIds.map(id => this.createPerson(id)),
      assigneeLabel: request.assigneeLabel,
      isActive: true,
      isComplete: false,
      priority: request.priority,
      totalTasks: request.tasks.length,
      completedTasks: 0,
      tasks: request.tasks.map(t => this.convertFromCreateTask(t))
    };

    return newTasklist;
  }
  private createPerson(id: string): Person {
    return {
      id: Math.random() * 1000000,
      name: {
        givenName: 'Mock',
        familyName: 'Mock'
      },
      assetIds: [],
      externalId: id
    };
  }

  getTasklists(page?: number, pageSize?: number, completed?: boolean, assigneeId?: number,
    ownerId?: number, priority?: string, externalId?: string, incidentExternalId?: string)
    : Observable<any> {
    let tasklists: Tasklist[];
    if (completed) {
      tasklists = tasklistData.getCompleted();
    } else {
      tasklists = tasklistData.getActive();
    }
    return mockHandler(getPage(tasklists, page, pageSize));
  }

  getTaskListById(id: string, includeActivity?: boolean, external?: boolean): Observable<any> {
    const tasklist = tasklistData.all.find(t => t.id === id);
    return mockHandler(getSingle(tasklist));
  }

  public deleteTasklist(id: string, external?: boolean): Observable<any> {
    tasklistData.delete(id);
    return mockHandler({});
  }

  addTasklist(createTaskListRequest?: CreateTaskListRequest): Observable<any> {
    const newTasklist: Tasklist = this.convertFromCreateTasklist(createTaskListRequest);
    tasklistData.add(newTasklist);
    return mockHandler({});
  }
}
